<template>
  <div id="app">
    <locationError :errorCode="errorCode"/>
    <router-view/>
  </div>
</template>

<script>
import store from '@/store/index'
import locationError from '@/components/locationError'

export default {
  name: 'App',
  components: {
   'locationError': locationError
 },
  data () {
    return {
      locationWatchId: '',
      errorCode: null,
    }
  },
  computed: {
    location: function() {
      return store.getters.location
    }
  },
  created() {
    const object = this
    this.locationWatchId = navigator.geolocation.watchPosition(function(position) {
      store.commit('setLocation', { latitude: position.coords.latitude, longitude: position.coords.longitude })
    } , function(error){
      object.errorCode = error.code
    },{})
    store.commit('setId', { id: localStorage["id"] })
    store.commit('setName', { name: localStorage["userName"] })
    store.commit('setPictureSrc', { pictureSrc: localStorage["pictureSrc"] })
  },
  destroyed() {
    navigator.geolocation.clearWatch(this.locationWatchId);
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue